/**
 * OAuth Client API types.
 *
 * Mirrors the backend OpenAPI contracts under `/dms/v1/auth/oauth/*`
 * (tenant.json, T20-124309). `clientSecret` is `null` for public clients
 * and is never returned for system clients (`custom = false`).
 */

export type OAuthClientResponseBody = {
  id: string;
  name: string;
  clientId: string;
  clientSecret: string | null;
  redirectUris: string[] | null;
  custom: boolean;
};

export type GetOAuthClientApiArg = {
  oauthClientId: string;
};

export type GetOAuthClientApiResponse = OAuthClientResponseBody;

export type CreatePublicOAuthClientRequestBody = {
  name: string;
  clientId: string;
  redirectUris: string[];
};

export type CreatePublicOAuthClientApiArg = {
  createPublicOAuthClientRequestBody: CreatePublicOAuthClientRequestBody;
};

export type CreatePublicOAuthClientApiResponse = {
  id: string;
};

export type CreateConfidentialOAuthClientRequestBody = {
  name: string;
  clientId: string;
  clientSecret: string;
  redirectUris: string[];
};

export type CreateConfidentialOAuthClientApiArg = {
  createConfidentialOAuthClientRequestBody: CreateConfidentialOAuthClientRequestBody;
};

export type CreateConfidentialOAuthClientApiResponse = {
  id: string;
};

export type UpdateOAuthClientRequestBody = {
  name: string;
  clientId: string;
  redirectUris: string[];
};

export type UpdateOAuthClientApiArg = {
  oauthClientId: string;
  updateOAuthClientRequestBody: UpdateOAuthClientRequestBody;
};

export type UpdateOAuthClientApiResponse = void;

export type DeleteOAuthClientApiArg = {
  oauthClientId: string;
};

export type DeleteOAuthClientApiResponse = void;

export type RegenerateOAuthClientSecretRequestBody = {
  clientSecret: string;
};

export type RegenerateOAuthClientSecretApiArg = {
  oauthClientId: string;
  regenerateOAuthClientSecretRequestBody: RegenerateOAuthClientSecretRequestBody;
};

export type RegenerateOAuthClientSecretApiResponse = void;
